import { MultiCountryFeasCpiData } from '../multi-country-draft/multi-country-draft.interface';
import { MultiCountryTotalCompletesHeader } from '../../../../../shared/interfaces/create-surveys.interface';
import { Constants as HeaderConstants } from '../../../../layout/header/header.constants';

export class MultiCountrySurveyFeasDataMapper<T extends { survey_id: number }> {
  constructor(
    private readonly _mcSurveys: T[],
    private readonly _cpiFeasData: MultiCountryFeasCpiData
  ) {}

  public transform(): T[] {
    return this._mcSurveys.map((mcSurvey) => {
      if (this._matched(mcSurvey)) {
        return this._mapper(mcSurvey);
      }
      return mcSurvey;
    });
  }

  private _mapper(mcSurvey: T): T {
    const {
      cpi,
      feasibility,
      buyerData: {
        expected_ir,
        expected_loi,
        completesRequired: completes_required,
        estimatedClicks: estimated_clicks,
        clickBalancing: click_balancing,
        field_time,
      },
      priceOverride,
      pricing_multiplier,
    } = this._cpiFeasData;
    return {
      ...mcSurvey,
      completes_required,
      estimated_clicks,
      click_balancing,
      expected_ir,
      expected_loi,
      field_time,
      cpi,
      feasibility,
      loading: false,
      price_override: priceOverride,
      pricing_multiplier,
    };
  }

  public find(): T | undefined {
    return this._mcSurveys.find((mcSurvey) => this._matched(mcSurvey));
  }

  private _matched(mcSurvey: T): boolean {
    return mcSurvey.survey_id === Number(this._cpiFeasData.surveyId);
  }
}

export class MultiCountryHeaderCompletesMapper<
  T extends { completes_required?: number; checked?: boolean }
> {
  constructor(private readonly _surveys: T[] = []) {}

  public transform(): MultiCountryTotalCompletesHeader {
    return {
      showTotalCompletes: this._show(),
      totalCompleteLabel: this._label(),
      totalCompletes: this._completes(),
    };
  }

  private _show(): boolean {
    return !!this._surveys?.length;
  }

  private _label(): string {
    return HeaderConstants.TOTAL_COMPLETES;
  }

  private _completes(): number {
    if (this._surveys[0]?.hasOwnProperty('checked')) {
      return this._surveys
        .filter((survey) => survey.checked)
        .reduce((total, survey) => total + (survey.completes_required || 0), 0);
    }

    return this._surveys.reduce(
      (total, survey) => total + (survey.completes_required || 0),
      0
    );
  }
}
